import { render, staticRenderFns } from "./MarketplaceWelcomeComponent.vue?vue&type=template&id=1e350ee3"
import script from "./MarketplaceWelcomeComponent.vue?vue&type=script&lang=js"
export * from "./MarketplaceWelcomeComponent.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceWelcomeComponent.vue?vue&type=style&index=0&id=1e350ee3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports